<template>
  <div class="company-select-container">
    <div class="label-container">
      <span class="label">{{ this.$t(`${i18nPrefix}.label.company`) }}</span>
      <div class="include-children-btn">
        <span class="btn-label">{{ this.$t(`${i18nPrefix}.label.includeChildrenCompany`) }}</span>
        <el-switch v-model="includeSubCompany" :width="28" @change="handleCompanyValueChange"></el-switch>
      </div>
    </div>
    <div class="select">
      <el-select v-model="selectCompanyId" clearable filterable :multiple="multiple" :filter-method="handleFilter" @change="handleCompanyValueChange" @clear="handleClearCompany">
        <el-option
          v-for="item in searchCompanyList"
          :key="item.id"
          :label="item.i18nName"
          :value="item.id"
          :style="{'padding-left':item.level*15+'px'}"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { addI18nProperty } from '@/i18n'
import _ from 'lodash'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    companyList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.job.list',
      companySearchKey: null,
      selectCompanyId: null,
      includeSubCompany: false
    }
  },
  computed: {
    searchCompanyList () {
      if (this.companySearchKey) {
        return _.filter(this.companyList, item => _.includes(item.i18nName.toLowerCase(), this.companySearchKey.toLowerCase()))
      } else {
        return this.companyList
      }
    }
  },
  methods: {
    handleFilter (keyword) {
      this.companySearchKey = keyword
    },
    handleClearCompany () {
      this.companySearchKey = null
    },
    handleCompanyValueChange () {
      const selected = _.filter(this.companyList, item => item.id === this.selectCompanyId).map(item => {
        addI18nProperty(item, 'i18nName', 'cn_name', 'name')
        return item
      })
      const value = {
        includeSubCompany: this.includeSubCompany,
        selected: selected
      }
      this.$emit('change', value)
      this.companySearchKey = null
    }
  },
  watch: {
    value: {
      handler () {
        if (this.value) {
          this.includeSubCompany = this.value.includeSubCompany
          if (this.value.selected?.length) {
            if (this.multiple) {
              this.selectCompanyId = _.map(this.value.selected, item => item.id)
            } else {
              this.selectCompanyId = this.value.selected[0].id
            }
          } else {
            this.selectCompanyId = null
          }
        } else {
          this.includeSubCompany = false
          this.selectCompanyId = null
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.company-select-container {
  .label-container {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    justify-content: space-between;
    color: #606266;
    .include-children-btn {
      display: inline-block;
      .btn-label {
        font-size: 10px;
        margin-right: 2px;
      }

      ::v-deep {
        .el-switch {
          height: 14px;
          .el-switch__core {
            height: 14px;
            &::after {
              width: 10px;
              height: 10px;
            }
          }

        }
        .is-checked {
          .el-switch__core {
            &::after {
              margin-left: -11px;
            }
          }
        }
      }

    }
  }
}
</style>
